const Vue = window.Vue
const VueResource = window.VueResource

import leaderboardWidget from './components/MainLeaderboard/MainLeaderboard.vue'

Vue.config.ignoredElements = ['ark-leaderboard', 'ark-div', 'ark-lb-tabs', 'ark-lb-tabs-list', 'ark-lb-tabs-item', 'ark-preload', 'ark-table', 'ark-tr', 'ark-td']

Vue.use(VueResource)
Vue.http.headers.common['X-CDN-Target-Host'] = window.location.hostname

window.arkWidgetLeaderboard = {
  leaderboardInstance: null,
  Init: function (inputData) {
    this.leaderboardInstance = new Vue({
      el: inputData.el,
      data: () => {
        return {
          config: inputData.config
        }
      },
      template: '<leaderboardWidget :config="config" />',
      components: { leaderboardWidget }
    })
  },
  refreshLeaderboard: function (data) {
    this.leaderboardInstance.$emit('refreshLeaderboard', data)
  },
  getTableByPeriod: function (period) {
    return this.leaderboardInstance.$children[0].leaderboardData[period]
  }
}
export default window.arkWidgetLeaderboard



// WEBPACK FOOTER //
// ./src/lib.js